import type {ConvertLeadToClientFormPayload} from "./convert-lead-to-client.schema";
import type {ConvertLeadToClientRequest} from "@project/sdk/sales";

export const convertLeadToClientMapper = {
  toSdk(payload: ConvertLeadToClientFormPayload): ConvertLeadToClientRequest {
    return {companyId: payload.companyId};
  },
};
